var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNotificationActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_716_3632",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_716_3632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.16675 8.33332C2.16675 7.1111 2.41341 5.95499 2.90675 4.86499C3.39953 3.77443 4.10425 2.83332 5.02091 2.04166L6.20841 3.20832C5.45841 3.8611 4.87508 4.62832 4.45841 5.50999C4.04175 6.39221 3.83341 7.33332 3.83341 8.33332H2.16675ZM17.1667 8.33332C17.1667 7.33332 16.9584 6.39221 16.5417 5.50999C16.1251 4.62832 15.5417 3.8611 14.7917 3.20832L15.9792 2.04166C16.8959 2.83332 17.6009 3.77443 18.0942 4.86499C18.587 5.95499 18.8334 7.1111 18.8334 8.33332H17.1667ZM3.83341 15.8333V14.1667H5.50008V8.33332C5.50008 7.18055 5.8473 6.1561 6.54175 5.25999C7.23619 4.36443 8.13897 3.77777 9.25008 3.49999V2.91666C9.25008 2.56943 9.37175 2.27443 9.61508 2.03166C9.85786 1.78832 10.1529 1.66666 10.5001 1.66666C10.8473 1.66666 11.1423 1.78832 11.3851 2.03166C11.6284 2.27443 11.7501 2.56943 11.7501 2.91666V3.49999C12.8612 3.77777 13.764 4.36443 14.4584 5.25999C15.1529 6.1561 15.5001 7.18055 15.5001 8.33332V14.1667H17.1667V15.8333H3.83341ZM10.5001 18.3333C10.0417 18.3333 9.64953 18.1703 9.32341 17.8442C8.99675 17.5175 8.83341 17.125 8.83341 16.6667H12.1667C12.1667 17.125 12.0037 17.5175 11.6776 17.8442C11.3509 18.1703 10.9584 18.3333 10.5001 18.3333ZM7.16675 14.1667H13.8334V8.33332C13.8334 7.41666 13.507 6.63193 12.8542 5.97916C12.2015 5.32638 11.4167 4.99999 10.5001 4.99999C9.58341 4.99999 8.79869 5.32638 8.14591 5.97916C7.49314 6.63193 7.16675 7.41666 7.16675 8.33332V14.1667Z",
    fill: "#594AE3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotificationActive);
export default __webpack_public_path__ + "static/media/icon-notification-active.e3985d04eb52b9130ab10b4f7aa0a165.svg";
export { ForwardRef as ReactComponent };